import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import { IcoChevronDown16 } from '@onefootprint/icons';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import type { ButtonSize, ButtonVariant } from '../../../button/button.types';
import Dropdown from '../../../dropdown';
const iconColorByVariant: Record<ButtonVariant, Color> = {
  primary: 'quinary',
  secondary: 'primary',
  destructive: 'quinary'
};
export type Option = {
  label: string;
  value: string;
  shortcut?: string[];
  onSelect: () => void;
  disabled?: boolean;
};
type DropdownOptionsProps = {
  options: Option[];
  loading?: boolean;
  disabled: boolean;
  onOptionChange: (option: Option) => void;
  flat?: boolean;
  width: string;
  variant: ButtonVariant;
  size: ButtonSize;
};
const DropdownOptions: React.FC<DropdownOptionsProps> = t0 => {
  const $ = _c(24);
  const {
    options,
    loading,
    disabled,
    width,
    variant,
    size,
    flat: t1,
    onOptionChange
  } = t0;
  const flat = t1 === undefined ? false : t1;
  const t2 = disabled || loading;
  const t3 = loading || undefined;
  let t4;
  if ($[0] !== width) {
    t4 = {
      width
    };
    $[0] = width;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = iconColorByVariant[variant];
  let t6;
  if ($[2] !== t5) {
    t6 = <span className="fp-split-chevron"><IcoChevronDown16 color={t5} /></span>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== flat || $[5] !== size || $[6] !== t3 || $[7] !== t4 || $[8] !== t6 || $[9] !== variant) {
    t7 = <TriggerHalf data-variant={variant} data-size={size} data-flat={flat} aria-label="More options" data-loading={t3} style={t4}>{t6}</TriggerHalf>;
    $[4] = flat;
    $[5] = size;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
    $[9] = variant;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t7) {
    t8 = <RadixDropdown.Trigger asChild={true} disabled={t2}>{t7}</RadixDropdown.Trigger>;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== onOptionChange || $[15] !== options) {
    let t10;
    if ($[17] !== onOptionChange) {
      t10 = option => <Dropdown.Item key={option.value} onSelect={() => onOptionChange(option)} className="flex justify-between items-center w-full" variant="radio" shortcutHint={option.shortcut}>{option.label}</Dropdown.Item>;
      $[17] = onOptionChange;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    t9 = options.map(t10);
    $[14] = onOptionChange;
    $[15] = options;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <Dropdown.Portal><Dropdown.Content sideOffset={8} align="end" className="min-w-[186px]"><Dropdown.RadioGroup className="min-w-[186px]">{t9}</Dropdown.RadioGroup></Dropdown.Content></Dropdown.Portal>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <Dropdown.Root>{t8}{t10}</Dropdown.Root>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};
const TriggerHalf = forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement> & {
  'data-variant': ButtonVariant;
  'data-size': ButtonSize;
  'data-flat': boolean;
}>((t0, ref) => {
  const $ = _c(7);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== ref || $[5] !== rest) {
    t1 = <button type="button" ref={ref} className="fp-split-trigger" {...rest}>{children}</button>;
    $[3] = children;
    $[4] = ref;
    $[5] = rest;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
});
export default DropdownOptions;